import { useParams, Link as RouterLink } from "react-router-dom";
import { Link as ChakraLink } from "@chakra-ui/react";

import { Grid, GridItem, Text, Box, VStack } from "@chakra-ui/react";

import { useEffect, useState } from "react";

import {
  doc,
  getDoc,
  collection,
  getDocs,
  query,
  where,
  orderBy,
} from "firebase/firestore";

import { db } from "../firebase";

import Topic from "../components/Topic";
import ReturnTopButton from "../components/Returntopbutton";

type SessionType = {
  id: string;
  day: string; // number → string
  title: string;
};

type CaseType = {
  id: string;
  casetitle: string;
  reader: string;
  sessionid: string;
  order: number;
};

export default function SessionDetail() {
  const { year, id } = useParams();

  const [session, setSession] = useState<SessionType | null>(null);

  const [chosenCases, setChosenCases] = useState<CaseType[]>([]);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      if (!id) return;

      try {
        // session取得
        const sessionRef = doc(db, "sessions", id);

        const sessionSnap = await getDoc(sessionRef);

        if (sessionSnap.exists()) {
          const sessionData = {
            id: sessionSnap.id,
            ...(sessionSnap.data() as Omit<SessionType, "id">),
          };

          setSession(sessionData);

          // cases取得
          const casesQuery = query(
            collection(db, "cases"),
            where("sessionid", "==", id),
            where("year", "==", year),
            orderBy("order")
          );

          const casesSnapshot = await getDocs(casesQuery);

          const casesData = casesSnapshot.docs.map((doc) => ({
            id: doc.id,
            ...(doc.data() as Omit<CaseType, "id">),
          }));

          setChosenCases(casesData);
        }
      } catch (error) {
        console.error("Firestore取得エラー:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id, year]);

  useEffect(() => {
    if (session?.title) {
      document.title = session.title;
    } else {
      document.title = "セッション詳細";
    }
  }, [session]);

  if (loading) {
    return (
      <Box p={8}>
        <Text>読み込み中...</Text>
      </Box>
    );
  }

  return (
    <Grid maxW="900px" mx="auto" px={4} py={8} alignItems="start">
      <GridItem mr={4}>
        <VStack align="stretch">
          <Box>
            {session?.title ? (
              <Topic title={session.title}>
                <></>
              </Topic>
            ) : (
              <Text color="red.500" fontWeight="bold">
                セッションが見つかりません。
              </Text>
            )}
          </Box>

          {chosenCases.length > 0 && (
            <Box mx={4}>
              <VStack align="stretch">
                {chosenCases.map((chosenCase) => (
                  <Box key={chosenCase.id} mb={4}>
                    <ChakraLink
                      as={RouterLink}
                      to={`/${year}/case/${chosenCase.id}`}
                      color="blue.700"
                      fontWeight="bold"
                      _hover={{ textDecoration: "underline" }}
                    >
                      {chosenCase.casetitle}
                    </ChakraLink>

                    <Text fontSize={13}>{chosenCase.reader}</Text>
                  </Box>
                ))}
              </VStack>
            </Box>
          )}
        </VStack>

        <Box mt={12}>
          <ReturnTopButton />
        </Box>
      </GridItem>
    </Grid>
  );
}
